import script from "./BillableHours.vue?vue&type=script&setup=true&lang=js"
export * from "./BillableHours.vue?vue&type=script&setup=true&lang=js"

import "./BillableHours.vue?vue&type=style&index=0&id=2544cb58&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2544cb58"]])

export default __exports__